<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="3">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">New organization</h4>
          </template>
          <template v-slot:body>
            <FormulateForm
              name="createOrganization"
              @submit="submitHandler"
              #default="{ isLoading }"
              v-model="formValues"
            >
              <b-form>
                <b-form-group label="organization name" label-for="name">
                  <FormulateInput
                    id="name"
                    name="name"
                    type="text"
                    validation="required"
                    input-class="form-control"
                  />
                </b-form-group>
                <b-form-group label="identification number" label-for="name">
                  <FormulateInput id="in" name="in" type="text" input-class="form-control" />
                </b-form-group>
                <b-form-group label="Admin" label-for="adminId">
                  <FormulateInput
                    name="adminId"
                    type="select"
                    placeholder="Choose user"
                    validation="required"
                    :options="
                      users.map((u) => ({
                        value: u.id,
                        label: u.prettyName,
                      }))
                    "
                  />
                </b-form-group>
                <b-form-group label="Parent organization" label-for="parentOrganizationId">
                    <FormulateInput
                      name="parentOrganizationId"
                      type="select"
                      placeholder="Choose organization"
                      validation="required"
                      :validation-messages="{
                        required: 'Parent organization needs to be defined.'
                      }"
                      :options="
                        parentOrganizations.map((u) => ({
                          value: u.id,
                          label: u.name,
                        }))
                      "
                    />
                  </b-form-group>
              </b-form>
              <div class="d-flex justify-content-center">
                <b-button
                  block
                  type="submit"
                  variant="primary"
                  class="mb-3 mr-1"
                  :disabled="isLoading"
                  :label="isLoading ? 'Loading...' : 'Submit this form'"
                >Create organization</b-button>
              </div>
            </FormulateForm>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
import { getAccountSync } from '../../Utils/account';
import { prettyName } from '../../Utils/getOwnerData';

const CREATE_ORGANIZATION = gql`
  mutation createOrganization(
    $name: String!,
    $in: String,
    $adminId: uuid,
    $parentOrganizationId: uuid,
    $organizationId: uuid!
  ) {
    insert_organizations_one(
      object: {
        name: $name,
        in: $in,
        admin_id: $adminId,
        parent_organization_id: $parentOrganizationId,
        organization_id: $organizationId
      }
    ) {
      id
      name
      in
      admin_id
      organization_id
    }
  }
`;
const LIST_USERS = gql`
  query listUsers {
    users(
      where: {
     		role: {
          _eq: sales_manager
        }   
      }
    ) {
      id
      email
      first_name
      last_name
    }
  }
`;
const LIST_ORGANIZATIONS_AND_ROOT_ORGANIZATION = gql`
  query listOrganizationsAndRootOrganization($userId: uuid!) {
    organizations {
      id
      name
    }
    users_by_pk(id: $userId){
      id
      organization_id
    }
  }
`;

export default {
  name: "OrganizationsCreate",
  data() {
    return {
      formValues: {
        name: "",
        in: null,
        adminId: null,
        parentOrganizationId: null,
      },
      organizations: [],
      rootOrganizationId: null,
    };
  },
  apollo: {
    users() {
      return {
        query: LIST_USERS,
        update: data => data.users.map(i => {
          return {
            ...i,
            prettyName: prettyName(i.first_name, i.last_name, i.email),
          }
        })
      };
    },
    organizations: {
      query: LIST_ORGANIZATIONS_AND_ROOT_ORGANIZATION,
      variables(){
        return {
          userId: getAccountSync().userId,
        }
      },
      result({data, loading}){
        if (!loading) {
          this.organizations = data.organizations;
          this.rootOrganizationId = data.users_by_pk.organization_id;
        }
      }
    }
  },
  computed: {
    parentOrganizations(){
      return this.organizations.filter(i => i.id !== this.$route.params.id)
    }
  },
  methods: {
    async submitHandler() {
      try {
        const saveResponse = await this.$apollo.mutate({
          mutation: CREATE_ORGANIZATION,
          variables: {
            ...this.formValues,
            organizationId: this.rootOrganizationId,
          }
        });
        this.$toast.success(`Organization created`);
        this.$formulate.reset("createOrganization");
        this.$apollo.queries.organizations.refetch();
      } catch (error) {
        this.$toast.error(`Failed to create organization: ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  },
  watch: {
    rootOrganizationId: function(n) {
      this.formValues.parentOrganizationId = n;
    }
  }
};
</script>
